<template>
  <div style="padding: 0 8px">
    <v-container
      v-if="
        !matchOddsMarket &&
        markets &&
        markets.length === 0 &&
        lineSession &&
        lineSession.data &&
        lineSession.data.length === 0 &&
        !loading
      "
    >
      <div>
        <data-not-found> </data-not-found>
      </div>
    </v-container>

    <div v-else>
      <v-container v-if="!matchOddsMarket" class="mx-auto pa-0">
        <div v-if="loading">
          <v-skeleton-loader
            tile
            light
            dense
            type="list-item-two-line"
          ></v-skeleton-loader>
        </div>
      </v-container>

      <div v-else>
        <page-title
          v-if="markets && markets.length > 0"
          :key="`page-title-${matchOddsMarket.id}`"
          :title="matchOddsMarket.event.name"
          favorite-btn
          :market-id="matchOddsMarket.id"
          :is-favorite="matchOddsMarket.isFavourite"
          :live-btn="hasVideo()"
          :event="matchOddsMarket"
          @liveBtnClick="toggleShowLive"
        />
        <!-- footbal-tennis score card -->
        <tennis-score-card
          v-if="matchOddsMarket.eventTypeId != 4 && videoUrlRtmp"
          :market-id="matchOddsMarket.eventTypeId"
        />
        <cricket-score-card
          v-if="matchOddsMarket.eventTypeId == 4 && videoUrlRtmp?.scorecard"
          :stats="videoUrlRtmp?.stats"
          :scorecard="videoUrlRtmp?.scorecard"
        />
        <v-alert
          v-if="
            matchOddsMarket &&
            matchOddsMarket.event &&
            matchOddsMarket.event.name === 'Binary'
          "
          tile
          text
          color="primary"
          dense
        >
          <v-container class="mx-auto pa-0">
            <div class="caption">
              <span
                ><v-icon size="14" class="pb-1" color="primary"
                  >mdi-information</v-icon
                ></span
              >
              Binary will be active from

              {{ $moment(startTime).format('h:mm a') }} to
              {{ $moment(endTime).format('h:mm a') }}.
            </div>
          </v-container>
        </v-alert>

        <v-container v-scroll.self="onScroll" class="mx-auto">
          <!--              todo add sportsbook-->
          <v-row>
            <v-col
              v-if="$breakpoint.mdAndUp"
              cols="12"
              md="3"
              lg="2"
              :class="{ 'pt-0': $breakpoint.mdAndUp }"
            >
              <!-- todo add sportsbook-->
              <sportsbook-category
                :orientation="'vertical'"
              ></sportsbook-category>
            </v-col>
            <v-col
              ref="sectionToShare"
              class="pa-0"
              cols="12"
              :class="{
                'col-md-10': !$auth.loggedIn,
                'col-md-6': $auth.loggedIn
              }"
            >
              <!-- only show desktop -->
              <!--              todo add bet-radar-->
              <bet-radar
                v-if="
                  scorecardCheck() &&
                  showScore &&
                  matchOddsMarket &&
                  matchOddsMarket.event &&
                  matchOddsMarket.event.name &&
                  matchOddsMarket.event.id &&
                  scorecardId
                "
                v-show="!showLive || $breakpoint.mdAndUp"
                :match-id="scorecardId"
                :category="matchOddsMarket.eventTypeId"
              ></bet-radar>

              <!-- only show mobile view start -->
              <!--              todo add video-->
              <v-responsive
                v-if="showLive && $breakpoint.smAndDown"
                :aspect-ratio="$breakpoint.smAndDown ? 16 / 9 : 16 / 6"
              >
                <live-match-hls
                  v-if="
                    matchOddsMarket &&
                    matchVideoUrl &&
                    sportIframeUrl &&
                    matchOddsMarket.eventTypeId &&
                    // matchOddsMarket.eventTypeId != '4' &&
                    $refs.tabs
                  "
                  class="responsive-iframe"
                  :class="{
                    'floating-tv': offsetTop > $refs.tabs.$el.offsetTop
                  }"
                  :video-url="sportIframeUrl"
                ></live-match-hls>

                <div
                  v-if="
                    matchOddsMarket &&
                    matchOddsMarket.eventTypeId &&
                    matchOddsMarket.eventTypeId === 'Binary' &&
                    matchVideoUrl
                  "
                >
                  <iframe
                    :src="'https://www.youtube.com/embed/' + matchVideoUrl"
                    frameborder="0"
                    class="responsive-iframe"
                    allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                    allowfullscreen
                  ></iframe>
                </div>
              </v-responsive>

              <!-- only show mobile view end  -->

              <!-- live game and upcoming tabs -->
              <v-tabs ref="tabs" v-model="tab" tile height="40" class="pb-2">
                <v-tab
                  ref="market"
                  class="tab-market body-2 p-0 font-weight-bold"
                >
                  Markets
                </v-tab>
                <v-tab
                  v-if="$auth.loggedIn && $breakpoint.smAndDown"
                  ref="openbets"
                  class="body-2 pa-0"
                >
                  Open Bets
                </v-tab>
                <v-btn
                  v-if="
                    version &&
                    version.projectCode &&
                    version.projectCode !== 'fps'
                  "
                  to="/referral"
                  class="align-self-center mr-2"
                  x-small
                  color="primary"
                >
                  Refer
                </v-btn>
                <!-- <a
                  href="/referral"
                  class="border-referral align-self-center mr-2"
                >
                  <v-img
                    :src="require('@/assets/images/referandearn.png')"
                    alt="Referral"
                    max-width="100"
                  ></v-img
                ></a> -->
                <v-dialog
                  v-model="dialog"
                  width="600"
                  scrollable
                  max-width="600px"
                >
                  <template #activator="{ on, attrs }">
                    <v-btn
                      v-if="
                        matchOddsMarket &&
                        matchOddsMarket.eventTypeId &&
                        (matchOddsMarket.eventTypeId === 2 ||
                          matchOddsMarket.eventTypeId === 1)
                      "
                      v-show="tab === 1"
                      icon
                      color="primary"
                      class="align-self-center"
                      height="35"
                      v-bind="attrs"
                      v-on="on"
                    >
                      <v-icon>mdi-information</v-icon>
                    </v-btn>
                  </template>
                  <v-card>
                    <v-card-title class="d-flex justify-sm-space-between">
                      <h5>Rules and Regulations</h5>
                      <button
                        class="pull-right cursor-pointer"
                        style="position: absolute; right: 1.5rem"
                        @click="dialog = false"
                      >
                        X
                      </button>
                    </v-card-title>
                    <premium-soccerinfo
                      v-if="matchOddsMarket.eventTypeId === 1"
                    />
                    <premium-tennisinfo
                      v-if="matchOddsMarket.eventTypeId === 2"
                    />
                    <v-divider></v-divider>
                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn color="primary" text @click="dialog = false">
                        Close
                      </v-btn>
                    </v-card-actions>
                  </v-card>
                </v-dialog>
                <v-btn
                  v-if="scorecardCheck()"
                  v-show="!showLive || $breakpoint.mdAndUp"
                  class="align-self-center mr-2"
                  x-small
                  color="green"
                  @click="hideScoreCard()"
                >
                  <span v-if="showScore === true">
                    <v-icon size="14">mdi-eye-off</v-icon></span
                  >
                  <span v-if="showScore === false">
                    <v-icon size="14">mdi-eye</v-icon></span
                  >
                </v-btn>
                <!-- <v-btn
                  v-if="shareCheck()"
                  x-small
                  color="primary"
                  class="align-self-center mr-2"
                  @click="share()"
                >
                  <v-icon size="14">mdi-share</v-icon>
                </v-btn> -->
              </v-tabs>
              <!--              todo start-->
              <v-skeleton-loader
                tile
                light
                dense
                :loading="loading"
                type="list-item-two-line"
              >
                <v-tabs-items v-model="tab">
                  <!-- Market ui Panel-->
                  <v-tab-item class="market_tab_content">
                    <!-- Match Odds -->
                    <div
                      v-if="Object.keys(sortedMarket).length"
                      class="markets"
                    >
                      <v-card
                        v-for="(key, j) in Object.keys(sortedMarket).filter(
                          (fixture) =>
                            fixture !== 'Fancy' &&
                            fixture !== 'Super Fancy' &&
                            fixture !== 'Premium Cricket' &&
                            !(
                              (fixture &&
                                fixture.toLowerCase() === 'tied match') ||
                              fixture.toLowerCase() === 'completed match' ||
                              ($route.params.category === 'Cricket' &&
                                $auth.user &&
                                !$auth.user.matchOdds &&
                                fixture.name &&
                                fixture.name.toLowerCase() === 'match odds')
                            )
                        )"
                        :key="sortedMarket[key][0].id + j"
                        tile
                        light
                        flat
                        class="mx-0 my-0 bookmaker bet-ladar-card"
                      >
                        <v-toolbar
                          v-if="
                            sortedMarket[key][0].runners &&
                            sortedMarket[key][0].runners.length > 0 &&
                            sortedMarket[key][0].id.includes('_SB')
                          "
                          class="caption grey lighten-2 font-weight-bold"
                          dense
                          flat
                          height="30"
                        >
                          Bookmaker (0% Commission &amp; Instant Bet)
                        </v-toolbar>
                        <div
                          v-if="
                            sortedMarket[key][0].runners &&
                            sortedMarket[key][0].runners.length > 0 &&
                            sortedMarket[key][0].status !== 'SUSPENDED'
                          "
                          class="pa-0"
                        >
                          <item-odds
                            :market="sortedMarket[key][0]"
                            :runners="
                              sortedMarket[key].reduce(
                                (acc, item) => [...acc, ...item.runners],
                                []
                              )
                            "
                            :market-id="sortedMarket[key][0].id"
                            :bookmaker="sortedMarket[key][0].bookMakerCustom"
                            :bookmaker-commission="
                              sortedMarket[key][0].bookmakerCommission
                            "
                            :max-commission="maxBookmakerCommission"
                            :event="sortedMarket[key][0]"
                            class="match-odds"
                          >
                          </item-odds>
                        </div>
                      </v-card>
                    </div>

                    <!-- Match Odds -->

                    <!-- line - market -->
                    <v-card
                      v-if="
                        lineSession &&
                        lineSession.data &&
                        lineSession.data.length
                      "
                      class="mx-0 my-0 bet-ladar-card"
                      tile
                      light
                      flat
                    >
                      <div
                        class="caption pr-0 py-0 pl-0 v-expansion-panel-header"
                      >
                        <simple-bar
                          hide-controls
                          title="Line Market"
                          :side-text="['Back', 'Lay']"
                        ></simple-bar>
                        <nuxt-link
                          class="d-none d-sm-flex font-weight-bold"
                          style="position: absolute; right: 10px"
                          to="/line-market-rules"
                          >Rules</nuxt-link
                        >
                      </div>
                      <div
                        v-if="
                          lineSession &&
                          lineSession.data &&
                          lineSession.data.length
                        "
                      >
                        <v-card
                          v-for="(fixture, j) in lineSession.data"
                          :key="fixture._id + '1' + j"
                          class="mx-0 my-0"
                          tile
                          light
                          flat
                        >
                          <div
                            v-if="fixture.runners && fixture.runners.length > 0"
                            class="pa-0 mt-2"
                          >
                            <!-- <pre>{{ fixture }}</pre> -->

                            <line-item-odds
                              :market="fixture"
                              :runners="fixture.runners"
                              :market-id="fixture.betfairId"
                              :bookmaker="fixture.bookMakerCustom"
                            >
                            </line-item-odds>
                          </div>
                        </v-card>
                        <ladder-overlay
                          v-if="
                            lineSession &&
                            lineSession.data &&
                            lineSession.data.length
                          "
                        ></ladder-overlay>
                      </div>
                    </v-card>
                    <!-- line - market  -->

                    <!-- Fancy -->
                    <v-card
                      v-if="
                        sortedMarket['Fancy'] && sortedMarket['Fancy'].length
                      "
                      class="mx-0 my-0 mt-2 mb-2 bet-ladar-card"
                      tile
                      light
                      flat
                    >
                      <div
                        class="caption pr-0 py-0 pl-0 v-expansion-panel-header"
                      >
                        <simple-bar
                          hide-controls
                          :bookmaker="true"
                          :title="
                            $route.params.category.toLowerCase() !== 'binary'
                              ? 'Fancy'
                              : 'Binary'
                          "
                          :side-text="['No', 'Yes']"
                        ></simple-bar>
                      </div>
                      <div class="pa-0 mt-2">
                        <fancy-odds
                          :market="sortedMarket['Fancy']"
                          :runners="
                            sortedMarket['Fancy'].reduce(
                              (acc, item) => [...acc, ...item.runners],
                              []
                            )
                          "
                          :max-commission="maxFancyCommission"
                        >
                        </fancy-odds>
                      </div>
                    </v-card>
                    <!-- Fancy -->

                    <!-- SuperFancy -->
                    <v-card
                      v-if="
                        sortedMarket['Super Fancy'] &&
                        sortedMarket['Super Fancy'].length
                      "
                      class="mx-0 my-0 bet-ladar-card"
                      tile
                      light
                      flat
                    >
                      <div
                        class="caption pr-0 py-0 pl-0 v-expansion-panel-header"
                      >
                        <simple-bar
                          hide-controls
                          :bookmaker="fancy.length > 0"
                          :title="
                            $route.params.category.toLowerCase() !== 'binary'
                              ? 'Super Fancy'
                              : 'Binary'
                          "
                          :side-text="['No', 'Yes']"
                        ></simple-bar>
                      </div>
                      <div class="pa-0 mt-2">
                        <fancy-odds
                          :market="sortedMarket['Super Fancy']"
                          :runners="
                            sortedMarket['Super Fancy'].reduce(
                              (acc, item) => [...acc, ...item.runners],
                              []
                            )
                          "
                          :max-commission="maxFancyCommission"
                        >
                        </fancy-odds>
                      </div>
                    </v-card>
                    <!-- SuperFancy -->

                    <!-- Tied/Completed Match -->
                    <div v-if="markets.length">
                      <v-card
                        v-for="(fixture, j) in markets.filter(
                          (fixture) =>
                            (fixture.name &&
                              fixture.name.toLowerCase() === 'tied match') ||
                            fixture.name.toLowerCase() === 'completed match'
                        )"
                        :key="fixture._id + '1' + j"
                        class="mx-0 my-0 bet-ladar-card"
                        tile
                        light
                        flat
                      >
                        <!-- <div
                          v-if="fixture.runners && fixture.runners.length > 0"
                          class="caption grey py-0 lighten-3 px-0 v-expansion-panel-header"
                          hide-actions
                        >
                          <simple-bar
                            hide-controls
                            :title="fixture.name"
                          ></simple-bar>
                        </div> -->
                        <div
                          v-if="fixture.runners && fixture.runners.length > 0"
                          class="pa-0 mt-2"
                        >
                          <item-odds
                            :market="fixture"
                            :runners="fixture.runners"
                            :market-id="fixture.betfairId"
                            :bookmaker="fixture.bookMakerCustom"
                          >
                          </item-odds>
                        </div>
                      </v-card>
                    </div>
                    <!-- Tied/Completed Match -->

                    <!-- Premium Cricket -->
                    <div
                      v-if="
                        sortedMarket['Premium Cricket'] &&
                        sortedMarket['Premium Cricket'].length
                      "
                    >
                      <v-card
                        v-for="(fixture, j) in sortedMarket['Premium Cricket']"
                        :key="fixture._id + '1' + j"
                        class="mx-0 my-0 bet-ladar-card"
                        tile
                        light
                        flat
                      >
                        <div
                          v-if="fixture.runners && fixture.runners.length > 0"
                          class="pa-0 mt-2"
                        >
                          <item-odds
                            :market="fixture"
                            :runners="fixture.runners"
                            :market-id="fixture.id"
                            :event="fixture"
                          >
                          </item-odds>
                        </div>
                      </v-card>
                    </div>
                    <!-- Premium Cricket -->
                  </v-tab-item>
                  <!-- open bets ui Panel -->
                  <v-tab-item v-if="$auth.loggedIn && $breakpoint.smAndDown">
                    <my-bets></my-bets>
                  </v-tab-item>
                </v-tabs-items>
              </v-skeleton-loader>
            </v-col>
            <!-- only show desktop view start -->

            <!--            todo live-->
            <v-col
              v-if="$auth.loggedIn && $breakpoint.mdAndUp"
              md="4"
              class="hits-sticky py-0"
              :class="{ 'matches-overflow pt-0': $breakpoint.mdAndUp }"
            >
              <v-responsive
                v-if="showLive && $breakpoint.mdAndUp"
                class="desktop-livetv"
                :aspect-ratio="16 / 9"
              >
                <live-match-hls
                  v-if="
                    matchOddsMarket &&
                    matchVideoUrl &&
                    sportIframeUrl &&
                    matchOddsMarket.eventTypeId &&
                    // matchOddsMarket.eventTypeId != '4' &&
                    $refs.tabs
                  "
                  class="responsive-iframe"
                  :class="{
                    'floating-tv': offsetTop > $refs.tabs.$el.offsetTop
                  }"
                  :video-url="sportIframeUrl"
                ></live-match-hls>

                <div
                  v-if="
                    matchOddsMarket &&
                    matchOddsMarket.eventType &&
                    matchVideoUrl
                  "
                >
                  <iframe
                    :src="'https://www.youtube.com/embed/' + sportIframeUrl"
                    frameborder="0"
                    class="responsive-iframe"
                    allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                    allowfullscreen
                  ></iframe>
                </div>
              </v-responsive>
              <desktop-rightbar></desktop-rightbar>
            </v-col>
            <!-- only show desktop view end -->
          </v-row>
        </v-container>
      </div>
    </div>
    <share-modal-status
      v-if="
        $auth.loggedIn &&
        version &&
        version.projectCode &&
        version.projectCode !== 'fps'
      "
      :share-button="shareCheckStatus()"
    />
  </div>
</template>

<script>
import { mapState } from 'vuex'
import upperFirst from 'lodash/upperFirst'
import PageTitle from '@/components/PageTitle'
import ItemOdds from '@/components/ItemOdds'
// import LineItemOdds from '@/components/LineItemOdds'
// import ThreeEtOdds from '@/components/ThreeEtOdds'
// import LotteryOdds from '@/components/LotteryOdds'
import FancyOdds from '@/components/FancyOdds'
// import LiveMatch from '@/components/LiveMatch'
import LiveMatchHls from '@/components/LiveMatchHls'
import BetRadar from '@/components/BetRadar'
import DesktopRightbar from '@/components/DesktopRightbar'
import SimpleBar from '@/components/toolbars/SimpleBar'
import MyBets from '@/components/MyBets'
// import socket from '@/plugins/socket.client'
import SportsbookCategory from '@/components/sections/SportsbookCategory'
import PremiumSoccerinfo from '@/components/rules-regulation/Premium-Soccer-Info.vue'
import PremiumTennisinfo from '@/components/rules-regulation/Premium-Tennis-Info.vue'
import dataNotFound from '@/components/dataNotFound.vue'
import LadderOverlay from '@/components/LadderOverlay'
import ShareModalStatus from '@/components/ShareModalStatus'
import TennisScoreCard from '@/components/sections/TennisScoreCard'
import CricketScoreCard from '@/components/sections/CricketScoreCard'

export default {
  components: {
    PageTitle,
    ItemOdds,
    TennisScoreCard,
    CricketScoreCard,
    // LineItemOdds,
    // ThreeEtOdds,
    SimpleBar,
    FancyOdds,
    // LotteryOdds,
    BetRadar,
    // LiveMatch,
    LadderOverlay,
    LiveMatchHls,
    MyBets,
    SportsbookCategory,
    DesktopRightbar,
    PremiumSoccerinfo,
    PremiumTennisinfo,
    dataNotFound,
    ShareModalStatus
  },
  // middleware: ['validateGame', 'validateUser'],
  data() {
    return {
      dialog: false,
      active: false,
      startTime: '2020-09-16T05:00:30.650Z',
      endTime: '2020-10-01T09:00:35.813Z',
      showScore: true,
      offsetTop: 0,
      tabs: null,
      showLive: false,
      domainName: process.env.DOMAIN_NAME,
      refresh: true,
      tab: 0,
      matchOddsMarket: undefined,
      matchVideoUrl: undefined,
      sportIframeUrl: undefined,
      videoUrl: undefined,
      maxBookmakerCommission: undefined,
      maxFancyCommission: undefined,
      matchBetradarId: undefined,
      sortedMarket: undefined,
      interval: ''
      // scorecardId: ''
    }
  },
  computed: {
    ...mapState({
      markets: (state) => state.matchInside.dataDetails,
      lineSession: (state) => state.matchInside.lineSession,
      threeEtMarkets: (state) => state.matchInside.threeEtData,
      videoUrlRtmp: (state) => state.matchInside.getVideoUrlRtmp,
      matchIds: (state) => state.matchInside.matchIds,
      fancy: (state) => state.matchInside.fancy,
      loading: (state) => state.matchInside.loading,
      selectedBetfairId: (state) => state.placeBet.runner,
      eventCompitions: (state) => state.sportsbookCategory.eventCompetionData,
      scorecardId: (state) => state.matchInside.scorecardId
    }),

    gameName() {
      return this.$route.params.category
    },
    version() {
      return this.$store.state.profile.appversion
    },
    eventGameData() {
      return this.$route.params.subCategory
    },
    fairplayUser() {
      return this.$store.state.profile.data
    }
  },
  watch: {
    // eventCompitions() {
    //   if (this.markets && this.markets[0]) {
    //     this.sportsRadarAdvertise()
    //   }
    // },
    matchOddsMarket() {
      // console.log('matchVideoUrl', this.matchVideoUrl)
      // console.log('oddsmarket', this.matchOddsMarket)
      // console.log('sportIframeUrl', this.sportIframeUrl)
      // await this.$store.dispatch('matchInside/getScoreCardId', {
      //   eventTypeId: this.matchOddsMarket.eventTypeId,
      //   eventId: this.matchOddsMarket.event.id
      // })
    },
    markets() {
      // console.log('markets', this.markets)
      const eventsMap = {}
      this.markets.forEach((e) => {
        const event = e.tabGroupName ? e.tabGroupName : e.name
        eventsMap[event]
          ? (eventsMap[event] = [...eventsMap[event], e])
          : (eventsMap[event] = [e])
      })
      this.sortedMarket = eventsMap
      // console.log('sortedMarket', this.sortedMarket)
    }
  },

  async created() {
    // console.log('!!! radar params', this.$route.params)
    // console.log('matchOddsMarket', this.matchOddsMarket)
    // console.log('scorecardId', this.scorecardId)
    // this.scorecardId = await this.$store.dispatch(
    //   'matchInside/getScoreCardId',
    //   {
    //     eventTypeId: '2',
    //     eventId: '31962617'
    //   }
    // )

    // const gameId = this.$route.params.id
    // this.$store.commit('openBets/set_pertucular_match', gameId)

    // let userId, customSession, bookmaker, lineSessionStatus
    // customSession = true
    // bookmaker = true
    // lineSessionStatus = true
    // const martketOnOff = []
    // // if (this.$auth.loggedIn) {
    // //   userId = this.$auth.user._id
    // //   customSession = this.$auth.user.customSession
    // //   bookmaker = this.$auth.user.bookmaker
    // //   lineSessionStatus = this.$auth.user.lineSession
    // //   let marketStatus = {}
    // //   // if (
    // //   //   this.$route.params.category === 'Cricket' &&
    // //   //   !this.$auth.user.matchOdds
    // //   // ) {
    // //   //   marketStatus = {
    // //   //     status: this.$auth.user.matchOdds,
    // //   //     name: 'Match Odds'
    // //   //   }
    // //   //   martketOnOff.push(marketStatus)
    // //   // }
    // //   if (
    // //     this.$route.params.category === 'Cricket' &&
    // //     !this.$auth.user.tiedMatch
    // //   ) {
    // //     marketStatus = {
    // //       status: this.$auth.user.tiedMatch,
    // //       name: 'Tied Match'
    // //     }
    // //     martketOnOff.push(marketStatus)
    // //   }
    // //   if (
    // //     this.$route.params.category === 'Cricket' &&
    // //     !this.$auth.user.completedMatch
    // //   ) {
    // //     marketStatus = {
    // //       status: this.$auth.user.completedMatch,
    // //       name: 'Completed Match'
    // //     }
    // //     martketOnOff.push(marketStatus)
    // //   }
    // //   // this.$store.dispatch('socketMain/joinRooms', {
    // //   //   socketId: socket.id,
    // //   //   gameId
    // //   // })
    // // }

    try {
      this.interval = setInterval(() => {
        this.$store.dispatch(
          'matchInside/getEventDetailsById',
          this.$route.params
        )
        this.$store.dispatch(
          'matchInside/getEventStatsById',
          this.$route.params
        )
      }, 1200)
      await Promise.all([
        this.$store.dispatch(
          'matchInside/getEventDetailsById',
          this.$route.params
        ),
        this.$store.dispatch(
          'matchInside/getEventStatsById',
          this.$route.params
        )

        // this.getFancy(this.$route.params.category),
        // this.getLineSession(this.$route.params.category),
        // this.$store.dispatch('matchInside/getConfigMaxLimits', {
        //   game: upperFirst(this.$route.params.category),
        //   loading: false
        // })
      ])
      if (
        upperFirst(this.$route.params.category) === 'Soccer' ||
        upperFirst(this.$route.params.category) === 'Tennis'
      ) {
        this.$store.dispatch('matchInside/getThreeTMarketsById', {
          game: upperFirst(this.$route.params.category),
          parentId: this.$route.params.id
        })
        // this.$store.dispatch('socketMain/joinRooms3ETBooks', {
        //   socketId: socket.id
        // })
      }
      if (
        this.markets.length === 0 &&
        this.linemarket.length === 0 &&
        this.fancy.length === 0 &&
        this.threeEtMarkets.length === 0
      ) {
        this.$router.push({
          path: '/'
        })
      }
      if (this.$route.params.betradar && !this.getBetradarID(this.markets)) {
        this.eventId = this.$route.params.betradar
      } else if (
        !this.$route.params.betradar &&
        !this.getBetradarID(this.markets)
      ) {
        this.eventId = this.getEventId(this.markets)
      } else {
        this.matchBetradarId = this.getBetradarID(this.markets)
      }
      this.matchOddsMarket = this.getMarkets(this.markets)
      // if (this.matchOddsMarket) {
      //   if (this.matchOddsMarket.maxBetBookmakerAmountForCommission) {
      //     this.maxBookmakerCommission =
      //       this.matchOddsMarket.maxBetBookmakerAmountForCommission
      //   }
      //   if (this.matchOddsMarket.maxBetFancyAmountForCommission) {
      //     this.maxFancyCommission =
      //       this.matchOddsMarket.maxBetFancyAmountForCommission
      //   }
      // }
      // this.getVideoOthersUrl(this.markets)

      // await this.joinSocket(gameId)
      this.shareStatus()
      if (this.$auth.loggedIn) {
        await this.$store.dispatch(
          'betBooks/get',
          this.matchOddsMarket.event.id,
          this.refresh
        )
      }
      // await this.$store.dispatch(
      //   'sportsbookCategory/getEventCompetition',
      //   this.eventGameData
      // )
    } catch (error) {}
    if (
      this.getMatchOddsId(this.markets) &&
      this.$route.params.category !== 'Cricket'
    ) {
      // socket.on('market_' + this.getMatchOddsId(this.markets), (data) => {
      //   this.$store.commit('matchInside/set_fancy', data)
      // })
    }

    // if (userId) {
    //   console.log('check 11111')
    // }
    if (this.$route.query.tab && this.tab <= 0) {
      this.tab = parseInt(this.$route.query.tab)
    }
  },
  beforeDestroy() {
    // await this.leaveSocket()
    // socket.off('marketEnable_' + this.$route.params.id)
    // socket.off('updateMatchStatus_' + this.$route.params.id)
    // socket.off('eventTypeMaxBet')
    clearInterval(this.interval)

    if (this.$auth.loggedIn) {
      // socket.off('winnerDeclared-' + this.$auth.user._id)
      // socket.off('winnerDeclared-fancy-' + this.$auth.user._id)
    }
    this.$store.commit('matchInside/reset')
    // if (this.getMatchOddsId(this.markets)) {
    //   socket.off('market_' + this.getMatchOddsId(this.markets))
    // }
  },
  methods: {
    getTime() {
      this.currentTime = this.$moment().format('h:mm a')
    },
    getFancy(category, customSession) {
      if (category !== 'Cricket' || customSession === true) {
        this.$store.dispatch('matchInside/getFancy', {
          market: this.$route.params.id
        })
      }
    },
    // getLineSession(category) {
    //   if (category === 'Cricket') {
    //     this.$store.dispatch('matchInside/getLineSession', {
    //       eventId: this.$route.params.id
    //     })
    //   }
    // },
    scorecardCheck() {
      const category = this.$route.params.category
      if (
        ((this.videoUrlRtmp?.showVisualisation ||
          this.videoUrlRtmp?.isBRScore) &&
          (category === '1' || category === '2')) ||
        ((this.videoUrlRtmp?.isBRScore ||
          this.videoUrlRtmp?.showVisualisation) &&
          category === '4')
      ) {
        return true
      } else {
        return false
      }
    },
    betfairOddsCheck(fixture) {
      if (fixture && fixture.betfairOdds === 'true') {
        return true
      } else if (fixture && fixture.betfairOdds === 'false') {
        return false
      } else {
        return true
      }
    },
    getMatchOddsId(markets) {
      let result = markets.find(
        (market) => market.name.toLowerCase() === 'match odds'
      )
      if (!result) {
        result = markets[0]
      } else if (result && result.betfairId) {
        return result.betfairId
      } else {
        return markets[0]
      }
    },
    // async getVideoOthersUrl(markets) {
    //   this.matchVideoUrl = this.hasVideo()
    //
    //   console.log('SUKKKAAAAAAAAAAAAAAAAAAAAAAAAAAAaa')
    //
    //   if (this.matchVideoUrl && this.$auth.loggedIn) {
    //     await this.$store
    //       .dispatch('matchInside/getVideoUrlRtmp', {
    //         channel: this.matchVideoUrl,
    //         clientIp: localStorage.getItem('AfterResultId')
    //       })
    //       .then(() => {
    //         this.matchVideoUrl = this.videoUrlRtmp
    //       })
    //   }
    //   console.log(
    //     'getItem AfterResultId >>>',
    //     localStorage.getItem('AfterResultId')
    //   )
    // },
    async getVideoOthersUrl(markets) {
      this.matchVideoUrl = this.hasVideo()

      if (this.matchVideoUrl && this.$auth.loggedIn) {
        await this.$store
          .dispatch('matchInside/getVideoUrl', {
            eventTypeId: this.matchOddsMarket.eventTypeId,
            eventId: this.matchOddsMarket.event.id,
            loading: true
          })
          .then((res) => {
            this.sportIframeUrl = res
            // console.log('sportIframeUrl', this.sportIframeUrl)
          })
      }
      // console.log('matchVideoUrl', this.matchVideoUrl)
    },
    hasVideo() {
      if (this.videoUrlRtmp && this.videoUrlRtmp.hasVideo) {
        // console.log('hasVideo', this.videoUrlRtmp.hasVideo)
        return this.videoUrlRtmp.hasVideo
      }
    },
    getMarkets(markets) {
      let result = markets?.find(
        (market) => market?.name.toLowerCase() === 'match odds'
      )
      if (!result) {
        result = markets[0]
      }
      return result
    },
    getEventId(markets) {
      let result = markets?.find(
        (market) => market?.name?.toLowerCase() === 'match odds'
      )
      if (!result) {
        result = markets[0]
      }
      return result.eventId
    },
    hideScoreCard() {
      this.showScore = !this.showScore
    },
    toggleShowLive(data) {
      if (data) {
        this.getVideoOthersUrl(this.markets)
      }
      this.showLive = data
    },
    onScroll() {
      if (process.client) {
        this.offsetTop = window.scrollY
      }
    },
    getBetradarID(markets) {
      let result = markets?.find(
        (market) => market?.name?.toLowerCase() === 'match odds'
      )
      if (!result) {
        result = markets[0]
      }
      return result.betradarId
    },
    async share() {
      let textData = `Hi, checkout my book for ${this.matchOddsMarket.eventName}.`
      let urlData = window.location.href
      if (process && process.env && process.env.REFFERAL) {
        textData = `${this.matchOddsMarket.eventName}`
        urlData = ''
        if (this.$auth.loggedIn) {
          textData = `Sign up using my referral code ${this.fairplayUser.referalLink}`
          urlData = ''
        }
      }
      await this.$store.dispatch('share/open', {
        ref: this.$refs.sectionToShare,
        text: textData,
        url: urlData
      })
    },
    shareCheck() {
      return navigator && navigator.share
    },
    async shareStatus() {
      let textData = `Hi, checkout my book for ${this.matchOddsMarket.eventName}.`
      let urlData = window.location.href
      if (process && process.env && process.env.REFFERAL) {
        textData = `${this.matchOddsMarket.eventName}`
        urlData = ''
        if (this.$auth.loggedIn) {
          textData = `Sign up using my referral code ${this.fairplayUser.referalLink}`
          urlData = ''
        }
      }
      await this.$store.dispatch('share/saveShareStatus', {
        ref: this.$refs.sectionToShare,
        text: textData,
        url: urlData
      })
    },
    shareCheckStatus() {
      const abc = this.shareCheck()
      if (abc) {
        return true
      }
    }
    /* sportsRadarAdvertise() { */
    /*  try { */
    /*    // ************************************************ *! */
    /*    // This Integartion is based on this Doc */
    /*    // https://wiki.ads.sportradar.com/en/dcp-quick-start-guide */
    /*    // status    	event	String	yes	not_started | live | closed | postponed | cancelled */
    /*    // Handled by @hitesh */
    /*    // ************************************************ *! */
    /*    // let checkStatus = 'not_started' */
    /*    // if ( */
    /*    //   this.markets[0].videoUrl && */
    /*    //   this.markets[0].inPlayStatus === 'Open' */
    /*    // ) { */
    /*    //   checkStatus = 'live' */
    /*    // } else if (this.markets[0].isSuspended === 'Yes') { */
    /*    //   checkStatus = 'cancelled' */
    /*    // } else if ( */
    /*    //   this.markets[0].videoUrl && */
    /*    //   this.markets[0].inPlayStatus === 'Close' */
    /*    // ) { */
    /*    //   checkStatus = 'closed' */
    /*    // } */
    /*    // console.log('this.markets', this.markets, window.srtmCommands) */
    /*    !* window.srtmCommands.push({ *! */
    /*    !*  event: 'srt.retargeting', *! */
    /*    !*  payload: { *! */
    /*    !*    sportsEvent: { *! */
    /*    //       match_id: this.markets[0].eventId, */
    /*    //       sr_match_id: '', */
    /*    //       team_home_name: this.markets[0].runners[0].name, */
    /*    //       team_home_name_short: this.markets[0].runners[0].name, */
    /*    //       team_home_logo: */
    /*    //         'https://fairplay-image.fairplay.club/fairplay-website-logo.png', */
    /*    //       team_away_name: this.markets[0].runners[1].name, */
    /*    //       team_away_name_short: this.markets[0].runners[1].name, */
    /*    //       team_away_logo: */
    /*    //         'https://fairplay-image.fairplay.club/fairplay-website-logo.png', */
    /*    //       scheduled: this.markets[0].marketStartTime, */
    /*    //       status: checkStatus, */
    /*    //       tournament_name: this.markets[0].eventName, */
    /*    //       sport: this.markets[0].eventType.name.toLowerCase(), */
    /*    //       odds_home: */
    /*    //         this.markets[0].runners[0] && this.markets[0].runners[0].batb */
    /*    //           ? this.markets[0].runners[0].batb[0][1].toString() */
    /*    //           : '', */
    /*    //       odds_away: */
    /*    //         this.markets[0].runners[1] && this.markets[0].runners[1].batb */
    /*    //           ? this.markets[0].runners[1].batb[0][1].toString() */
    /*    //           : '', */
    /*    //       odds_draw: */
    /*    //         this.markets[0].runners[2] && this.markets[0].runners[2].batb */
    //     //           ? this.markets[0].runners[2].batb[0][1].toString()
    //     //           : ''
    //     //     }
    //     //   }
    //     // })
    //   } catch (err) {
    //     console.log(err)
    //   }
    // }
  }
}
</script>
<style scoped>
.grey-border-b {
  border-bottom: 1px solid #e0e0e0 !important;
}
.bookmaker .v-sheet.v-toolbar {
  padding: 0.5rem 0;
  height: auto !important;
}
.bookmaker .v-toolbar__content {
  text-align: justify;
  height: auto !important;
}
.nuxt-progress {
  display: none;
}
.v-sheet.v-card.bet-ladar-card {
  border-radius: 16px !important;
}
/* .v-card .match-odds {
  border-bottom-left-radius: 16px !important;
  border-bottom-right-radius: 16px !important;
} */
.markets {
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.v-toolbar {
  border-radius: 0px !important;
  margin-bottom: 2px;
}
.v-btn:not(.v-btn--round).v-size--default {
  padding: 0 10px !important;
}
.v-tabs .v-slide-group__content {
  width: 100% !important;
  display: flex !important;
  align-items: center !important;
  justify-content: space-between;
}
</style>
